// extracted by mini-css-extract-plugin
module.exports = {"paypal_modal__close_button":"modal-close-button-module--paypal_modal__close_button--243M9"};